<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormNote class="mb-6"
          >Note: Pencarian hanya bisa berdasarkan nomor rekening member yang
          lengkap. <strong>Form ini hanya untuk menggabungkan member yang sama.</strong></FormNote
        >

        <FormRow class="mb-4" :required="true">
          <template #label>From Member</template>
          <template #field>
            <multiselect
              v-model="formData.from"
              :options="listMemberFrom"
              :loading="listMemberFromLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              track-by="id"
              label="tooltip"
              tag-placeholder="Press enter to choose"
              placeholder="Search member bank's account number"
              :showLabels="false"
              :internal-search="false"
              :searchable="true"
              @search-change="getListMemberFrom"
              @input="showMemberFromData"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.from.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.from.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-20" v-if="tableData.from.rows.length > 0">
          <template #label>Results</template>
          <template #field>
            <vue-good-table
              mode="remote"
              theme="polar-bear"
              :rows="tableData.from.rows"
              :columns="tableData.columns"
              :total-rows="tableData.from.totalRows"
              :is-loading.sync="tableData.from.isLoading"
              :pagination-options="{
                enabled: false,
              }"
              :search-options="{
                enabled: false,
              }"
              :sort-options="{
                enabled: false,
              }"
              styleClass="vgt-table striped bordered"
            >
              <template slot="table-row" slot-scope="props">
                <template v-if="props.column.field == 'bank_accounts'">
                  <template v-if="props.row.bank_accounts.length > 0">
                    <span
                      class="block"
                      v-for="bank in props.row.bank_accounts"
                      :key="bank.id"
                    >
                      <span>{{ bank.tooltip }}</span>
                    </span>
                  </template>
                  <template v-else>-</template>
                </template>
                <template v-else-if="props.column.field == 'accounts'">
                  <template v-if="props.row.accounts.length > 0">
                    <span
                      class="block"
                      v-for="account in props.row.accounts"
                      :key="account.id"
                    >
                      <span>{{ account.tooltip }}</span>
                      <span class="block mt-1 mb-2"
                        ><font-awesome-icon
                          :icon="['fas', 'coins']"
                          class="mr-1"
                        />
                        <template v-if="account.balance">{{
                          account.balance
                        }}</template
                        ><template v-else>0.00</template></span
                      >
                    </span>
                  </template>
                  <template v-else>-</template>
                </template>
              </template>
            </vue-good-table>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true" v-if="formData.from">
          <template #label>To Member</template>
          <template #field>
            <multiselect
              v-model="formData.to"
              :options="listMemberTo"
              :loading="listMemberToLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              track-by="id"
              label="tooltip"
              tag-placeholder="Press enter to choose"
              placeholder="Search member bank's account number"
              :showLabels="false"
              :internal-search="false"
              :searchable="true"
              @search-change="getListMemberTo"
              @input="showMemberToData"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.to.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.to.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" v-if="tableData.to.rows.length > 0">
          <template #label>Results</template>
          <template #field>
            <vue-good-table
              mode="remote"
              theme="polar-bear"
              :rows="tableData.to.rows"
              :columns="tableData.columns"
              :total-rows="tableData.to.totalRows"
              :is-loading.sync="tableData.to.isLoading"
              :pagination-options="{
                enabled: false,
              }"
              :search-options="{
                enabled: false,
              }"
              :sort-options="{
                enabled: false,
              }"
              styleClass="vgt-table striped bordered"
            >
              <template slot="table-row" slot-scope="props">
                <template v-if="props.column.field == 'bank_accounts'">
                  <template v-if="props.row.bank_accounts.length > 0">
                    <span
                      class="block"
                      v-for="bank in props.row.bank_accounts"
                      :key="bank.id"
                    >
                      <span>{{ bank.tooltip }}</span>
                    </span>
                  </template>
                  <template v-else>-</template>
                </template>
                <template v-else-if="props.column.field == 'accounts'">
                  <template v-if="props.row.accounts.length > 0">
                    <span
                      class="block"
                      v-for="account in props.row.accounts"
                      :key="account.id"
                    >
                      <span>{{ account.tooltip }}</span>
                      <span class="block mt-1 mb-2"
                        ><font-awesome-icon
                          :icon="['fas', 'coins']"
                          class="mr-1"
                        />
                        <template v-if="account.balance">{{
                          account.balance
                        }}</template
                        ><template v-else>0.00</template></span
                      >
                    </span>
                  </template>
                  <template v-else>-</template>
                </template>
              </template>
            </vue-good-table>
          </template>
        </FormRow>
      </template>

      <template #footer>
        <FormRow class="mb-0">
          <template #field>
            <BaseButton type="submit">Submit</BaseButton>
          </template>
          <template #link>
            <div class="ml-4 poppins">
              or
              <router-link :to="{ name: 'MemberList' }" class="link ml-2"
                >Back to List Members</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>
  </form>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { submitFormMixin } from "@/mixins/submitFormMixin";

export default {
  mixins: [submitFormMixin],
  components: {
    VueGoodTable,
    Multiselect,
  },
  validations() {
    return {
      formData: {
        from: {
          required,
        },
        to: {
          required,
        },
      },
    };
  },
  created() {
    this.$_debounceTimer = null;
  },
  data: () => {
    return {
      listMemberFrom: [],
      listMemberFromLoading: false,

      listMemberTo: [],
      listMemberToLoading: false,

      formData: {
        from: null,
        to: null,
      },

      tableData: {
        from: {
          isLoading: false,
          rows: [],
          totalRows: 0,
        },
        to: {
          isLoading: false,
          rows: [],
          totalRows: 0,
        },
        columns: [
          {
            label: "Name",
            field: "name",
          },
          {
            label: "Bank Accounts",
            field: "bank_accounts",
          },
          {
            label: "Account IDs",
            field: "accounts",
          },
        ],
      },
    };
  },
  methods: {
    showMemberFromData(memberFrom) {
      const memberFromUuid = memberFrom.member.uuid;

      this.tableData.from.isLoading = true;
      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            `/member?uuid=${memberFromUuid}&page=1&limit=10`
        )
        .then((res) => {
          this.tableData.from.rows = [res.data.data];
          this.tableData.from.totalRows = res.data.total;
        });
    },
    showMemberToData(memberTo) {
      const memberToUuid = memberTo.member.uuid;

      this.tableData.to.isLoading = true;
      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            `/member?uuid=${memberToUuid}&page=1&limit=10`
        )
        .then((res) => {
          this.tableData.to.rows = [res.data.data];
          this.tableData.to.totalRows = res.data.total;
        });
    },
    getListMemberTo(query) {
      if (query.length >= 8) {
        this.debounce(() => {
          this.$http
            .get(
              process.env.VUE_APP_API_URL +
                "/member-merge?number=" +
                query +
                "&exclude_member_id=" +
                this.formData.from.member.id
            )
            .then((res) => {
              if (res.status == 200) {
                const response = res.data;

                if (response) {
                  this.listMemberTo = response.data;
                }
              }
            })
            .catch((error) => {
              if (error.response) {
                this.formError = [];

                if (error.response.status == 404) {
                  // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
                } else if (error.response.status == 409) {
                  // this.formError[0] = error.response.data;
                } else {
                  const { data } = error.response.data;
                  for (var err in data) {
                    this.formError.push(data[err]);
                  }
                }
              }
            })
            .finally(() => {
              this.listMemberToLoading = false;
            });
        }, 500);
      }
    },
    getListMemberFrom(query) {
      if (query.length >= 8) {
        this.debounce(() => {
          this.$http
            .get(process.env.VUE_APP_API_URL + "/member-merge?number=" + query)
            .then((res) => {
              if (res.status == 200) {
                const response = res.data;

                if (response) {
                  this.listMemberFrom = response.data;
                }
              }
            })
            .catch((error) => {
              if (error.response) {
                this.formError = [];

                if (error.response.status == 404) {
                  // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
                } else if (error.response.status == 409) {
                  // this.formError[0] = error.response.data;
                } else {
                  const { data } = error.response.data;
                  for (var err in data) {
                    this.formError.push(data[err]);
                  }
                }
              }
            })
            .finally(() => {
              this.listMemberFromLoading = false;
            });
        }, 500);
      }
    },
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;
        this.$store.commit("toggleLoading");

        this.$http({
          method: "patch",
          url: process.env.VUE_APP_API_URL + "/member-merge",
          data: this.formData,
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$router.push({ name: this.$route.meta.baseRoute }, () => {
                this.$swal({
                  position: "bottom-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 5000,
                  timerProgressBar: true,
                  title: res.data.message,
                  icon: "success",
                });
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                // this.formError[0] = error.response.data;
              } else {
                const { data } = error.response.data;
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
  },
};
</script>
